export default "__VITE_ASSET__Cr3Cbw_W__"